import React, { Component } from 'react'; //eslint-disable-line
import connect from "react-redux/es/connect/connect";
import { Icon, Button } from 'antd';
import { hashHistory } from "react-router";
import { controlSidebar } from "../../../actions/optionsStoreActions";

import LinkComponent from '../../LinkComponent/LinkComponent';
import FilterPanel from '../FilterPanel';

import './pageHeader.less';

const exceptionTitles = [
	"Messages",
	"Subscriptions",
	"Channels",
	"My Profile",
	"Upcoming Events",
	"Saved Events",
	"Webinars",
	"Conferences",
	"Surgeries",
	"Create Event",
	"Admin Configuration",
	"Search Results",
	"Home",
	"Edit Event" ];

class PageHeader extends Component {
	state = {
		activeMobileSearch: false,
		mobileSearchValue: '',
		width: 0,
		height: 0
	};

	componentDidMount() {
		this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

	controlMobileSearch = () => {
    this.setState((prevState) => {
      return {
        activeMobileSearch: !prevState.activeMobileSearch
      }
    });
  };

  searchResultHandler = () => {
		const { mobileSearchValue } = this.state;
		const { mobileTypeSearch, reverseRedirection } = this.props;

		this.controlMobileSearch();

		!reverseRedirection ?
			hashHistory.push(`/Search?type=${mobileTypeSearch}&value=${mobileSearchValue}`)
    	: hashHistory.push(`/Search?type=${mobileTypeSearch}&value=${mobileSearchValue}&redirect=${reverseRedirection}`);
  };

  mobileSearchValueHandler = (e) => {
    this.setState({ mobileSearchValue: e.target.value });
  };

  resetMobileSearchHandler = () => {
    this.setState({ mobileSearchValue: '' })
	};

	render() {
		const { mobileSearchValue, activeMobileSearch, width } = this.state;
		const {
			pseudoBack,
      backTo,
			title,
			extra,
			extraMobile,
			mobileTitleSearch,
			mobileTypeSearch,
			options,
			activeChat,
			activeChatHandler
		} = this.props;

		const needToShow = exceptionTitles.includes(title);
		let backToLink = !needToShow && ((options.previousPath || backTo) ? options.previousPath || backTo : null);

		return (
			<div className="header">
				<div className={activeMobileSearch ? "header-inner-mobile" : "header-inner"}>
					{
            <div
              className={`sidebar-menu-trigger`}
              onClick={() => this.props.controlSidebar(false)}
						>
              <Icon type="menu" />
						</div>
					}
					{title === "Messages" && activeChat && !activeMobileSearch && width < 1024 && (
						<div className="header-back">
							<Icon
								type="arrow-left"
								onClick={activeChatHandler} />
						</div>
					)}
					{backToLink && !pseudoBack && !activeMobileSearch && (
						<div className="header-back">
							<LinkComponent
								isShow={!needToShow}
								pathTo={backToLink}
							>
								<Icon type="arrow-left" /> Back
							</LinkComponent>
						</div>
					)}
					{pseudoBack && !activeMobileSearch && (
						<div className="header-back">
							<Icon
								type="arrow-left"
								onClick={() => pseudoBack({ askForLogin: false})}
							/>
						</div>
					)}
					{title && !activeMobileSearch && (
						<div className="header-title">
							<h1>{title}</h1>
						</div>
					)}
					{extra && <div className="header-extra">{extra}</div>}
					{
						extraMobile && !activeMobileSearch && (
							<div
								className="header-extra-mobile"
								onClick={this.controlMobileSearch}
							>
								{extraMobile}
							</div>
						)
					}
					{
						activeMobileSearch && (
							<div className="mobile-searching-panel">
								<FilterPanel
									// filter={this.filterBy}
									title={mobileTitleSearch}
									type={mobileTypeSearch}
									mobileSearchValue={mobileSearchValue}
									mobileSearchValueHandler={this.mobileSearchValueHandler}
									controlMobileSearch={this.controlMobileSearch}
									resetMobileSearchHandler={this.resetMobileSearchHandler}
									activeMobileSearch={activeMobileSearch}
								/>
								<Button
									type="primary"
									shape="circle"
									icon="search"
									onClick={this.searchResultHandler}
								/>
							</div>
						)
					}
				</div>
			</div>
		);
	}
}

export default connect( (state) => ({ options: state.options }),{ controlSidebar } )(PageHeader);



// WEBPACK FOOTER //
// ./src/components/Modules/PageHeader/index.js